export default {
  setProfile: (state, profile) => {
    state.profile = profile
  },
  setImage: (state, data) => {
    state.image = data
  },
  reset: (state, data) => Object.assign(state, data)
}
